import { ActionButton, ActionButtonType, NavigationButton, NavigationButtonType } from "@octopusdeploy/design-system-components";
import { ProcessType } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { Action, useProjectScopedAnalyticActionDispatch } from "~/analytics/Analytics";
import { processScopedEditPermission } from "~/areas/projects/components/Process/Common/CommonProcessHelpers";
import { useProcessContext } from "~/areas/projects/components/Process/Contexts/ProcessContext";
import { useProcessQueryStringContext } from "~/areas/projects/components/Process/Contexts/ProcessQueryString/ProcessQueryStringContext";
import { isRunbookProcessIdentifier } from "~/areas/projects/components/Process/types";
import { useProjectContext } from "~/areas/projects/context/index";
import { PermissionCheck } from "~/components/PermissionCheck/index";
interface AddProcessTemplateStepButtonProps {
    projectId: string;
}
export function AddDeploymentProcessTemplateStepButton({ projectId }: AddProcessTemplateStepButtonProps) {
    const processQueryStringContext = useProcessQueryStringContext();
    const dispatchAction = useProjectScopedAnalyticActionDispatch(projectId);
    return (<PermissionCheck permission={processScopedEditPermission(ProcessType.Deployment)} project={projectId} wildcard={true}>
            <ActionButton type={ActionButtonType.Secondary} label="Add Process Template" onClick={() => {
            processQueryStringContext.actions.addBlueprintStep();
            dispatchAction("Add Process Template Step", { resource: "Deployment Process", action: Action.Add });
        }}/>
        </PermissionCheck>);
}
export function AddRunbookProcessTemplateStepButton({ projectId }: AddProcessTemplateStepButtonProps) {
    const processContext = useProcessContext();
    const processIdentifier = processContext.state.processIdentifier;
    const projectContext = useProjectContext();
    const dispatchAction = useProjectScopedAnalyticActionDispatch(projectId);
    if (!isRunbookProcessIdentifier(processIdentifier)) {
        return null;
    }
    const routeValues = {
        spaceId: processIdentifier.spaceId,
        projectSlug: projectContext.state.model.Slug,
        processId: processIdentifier.id,
        runbookId: processIdentifier.runbookId,
    };
    const href = links.projectRunbookProcessStepsPage.generateUrl(routeValues, { new: true, actionType: "Octopus.ProcessTemplate" });
    const logAction = () => dispatchAction("Add Process Template Step", { resource: "Runbook Process", action: Action.Add });
    return (<PermissionCheck permission={processScopedEditPermission(ProcessType.Runbook)} project={projectId} wildcard={true}>
            <NavigationButton label={"Add Process Template"} href={href} type={NavigationButtonType.Secondary} onClick={logAction}/>
        </PermissionCheck>);
}
